import Modal from './ModalAntd';

export default Modal;
